/**
 * Dynamic Card Type Enum
 * 
 * PrimeNG Types/Components
 */
 export enum DynamicCardType {
   Card = 1,
   Fieldset,
   Accordion,
   Divider,
   Panel,
   TabView,
   MiscellaneousBuild,
   BuildHistory,
   History,
 }
